export const RouteName = {

    // global
    AUTH_SCREEN: '/',
    SETTING_SCREEN: '/Settings',
    COUPON: '/Coupon',

    // Parent
    DASHBOARD_SCREEN: '/Dashboard',
    MYCHILDREN_SCREEN: '/MyChildren',
    CALENDAR_SCREEN: '/Calendar',
    CHILD_RESULT_SCREEN: '/MyChildren/Child_Result',

    // teacher
    DASHBOARD_SCREEN_TEACHER: '/Dashboard_Teacher',
    COURSES_SCREEN: '/Courses',
    STUDENTS_SCREEN: '/Students',
    STUDENT_DETAILS_SCREEN: '/Students/Student_Details',
    FEEDBACK_SCREEN: '/Feedback',
    ADD_QUIZ: '/my_quizzes/add_quiz',
    UPDATE_QUIZ: '/my_quizzes/update_quiz',
    MY_QUIZZES: '/my_quizzes',

    // Student
    DASHBOARD_SCREEN_STUDENT: '/Dashboard_Student',

    RESULTS_SCREEN: '/Results',
    QUIZZES_DETAILS: '/Results/Quizzes_details',

    ROOT_SUBJECTS: '/Subjects',
    SUBJECTS_SCREEN: '/Subjects/Overview',
    TOPICS_SUBJECTS: '/Subjects/Topics',
    STUDENT_FEEDBACK: '/Subjects/Feedback',

    LESSONS_STUDENT: '/Subjects/Topics/Lessons',
    MATERIAL_STUDENT: '/Subjects/Topics/Lessons/Material',

    // games
    GAMES: '/Subjects/Games',
    PLAY_GAME: '/Play_Games',
    MODE_SELECT: '/mode-select',
    DIFFICULTY_LEVEL: '/difficulty-level',

    DAILY_QUIZ_ROOT: '/Subjects/Daily_Quiz',
    DAILY_QUIZ: '/Subjects/Daily_Quiz/Overview',
    SOLO_QUIZ: '/Subjects/Daily_Quiz/Singleplayer_Quiz',
    MULTIPLAYER_QUIZ: '/Subjects/Daily_Quiz/Multiplayer_Quiz',
    QUIZ_CONFIRMATION: '/Subjects/Daily_Quiz/Confirmation',
    QUIZ_RESULT: '/Subjects/Daily_Quiz/Result',

    // payments routes
    SUBSCRIPTION: '/subscription',
    CREATE_COUPON: '/coupon/create',
    GET_COUPON: '/coupon',
    DELETE_COUPON: '/coupon/delete',
    USE_COUPON: '/coupon/usecoupon'




};